/** Automated points rule identifiers (UI form keys). */
const RULE_KEYS = Object.freeze({
  ON_TIME_FOR_SCHOOL: "onTimeForSchool",
  ON_TIME_FOR_CLASS: "onTimeForClass"
})

/** Backend automation_type values. */
const AUTOMATION_TYPE = Object.freeze({
  ON_TIME_FOR_SCHOOL: "on_time_for_school",
  ON_TIME_FOR_CLASS: "on_time_for_class"
})

/** PBIS automated_category_id values (seeded categories). */
const AUTOMATED_CATEGORY_ID = Object.freeze({
  ON_TIME_FOR_SCHOOL: 1,
  ON_TIME_FOR_CLASS: 2
})

/** Maps API category id → form rule key. */
const RULE_KEY_BY_CATEGORY_ID = Object.freeze({
  [AUTOMATED_CATEGORY_ID.ON_TIME_FOR_SCHOOL]: RULE_KEYS.ON_TIME_FOR_SCHOOL,
  [AUTOMATED_CATEGORY_ID.ON_TIME_FOR_CLASS]: RULE_KEYS.ON_TIME_FOR_CLASS
})

/** Maps API automation type → form rule key. */
const RULE_KEY_BY_AUTOMATION_TYPE = Object.freeze({
  [AUTOMATION_TYPE.ON_TIME_FOR_SCHOOL]: RULE_KEYS.ON_TIME_FOR_SCHOOL,
  [AUTOMATION_TYPE.ON_TIME_FOR_CLASS]: RULE_KEYS.ON_TIME_FOR_CLASS
})

/**
 * Single source of truth for automated rules.
 * Add new rules here to minimize downstream changes.
 */
const RULE_DEFINITIONS = Object.freeze([
  {
    ruleKey: RULE_KEYS.ON_TIME_FOR_SCHOOL,
    automationType: AUTOMATION_TYPE.ON_TIME_FOR_SCHOOL,
    legacyCategoryId: AUTOMATED_CATEGORY_ID.ON_TIME_FOR_SCHOOL
  },
  {
    ruleKey: RULE_KEYS.ON_TIME_FOR_CLASS,
    automationType: AUTOMATION_TYPE.ON_TIME_FOR_CLASS,
    legacyCategoryId: AUTOMATED_CATEGORY_ID.ON_TIME_FOR_CLASS
  }
])

const FREQUENCY = Object.freeze({
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly"
})

const FREQUENCY_VALUES = Object.freeze([
  FREQUENCY.DAILY,
  FREQUENCY.WEEKLY,
  FREQUENCY.MONTHLY
])

/** GET/PUT — `apiV8nocache` base is already `/api/v8`. */
const AUTOMATED_POINTS_API_PATH = "/admin/pbis/automated-points-settings"

export default {
  RULE_KEYS,
  AUTOMATION_TYPE,
  AUTOMATED_CATEGORY_ID,
  RULE_KEY_BY_CATEGORY_ID,
  RULE_KEY_BY_AUTOMATION_TYPE,
  RULE_DEFINITIONS,
  FREQUENCY,
  FREQUENCY_VALUES,
  AUTOMATED_POINTS_API_PATH
}
